import { House } from '@lucide/vue'

import { AssetWizardFlow } from '@/store/ai/assetWizard/utils/types'

import {
  amountField,
  assetNameField,
  currencyField,
  dateField,
  descriptionField,
} from '../utils/fields'
import { OWNERSHIP_STEP, SUMMARY_STEP, TAGS_STEP, VALUE_STEP } from '../utils/steps'
import { WizardDefinition } from '../utils/types'

import { realEstateSchema } from './schema'
import { create } from './create'
import { TagRef } from '@/entities/tags/utils/types'

const PROPERTY_TYPE = 'property'

const DEFAULT_TAGS: TagRef[] = [
  { tag_name: 'Asset Class', tag_value: 'Real Estate' },
  { tag_name: 'Investment Strategy', tag_value: 'Personal Property' },
]

/** A property bought outright. The financed version is its own wizard. */
export const realEstateWizard: WizardDefinition = {
  flow: AssetWizardFlow.REAL_ESTATE,
  label: 'Real estate',
  icon: House,
  schema: realEstateSchema,
  steps: [
    OWNERSHIP_STEP,
    {
      key: 'property',
      label: 'Property',
      heading: 'What is this?',
      description: 'Houses, apartments, land and other real estate all go here.',
      fields: [
        assetNameField('Property name', 'Name this property'),
        descriptionField(),
      ],
    },
    {
      key: 'purchase',
      label: 'Purchase',
      heading: 'How much did you pay?',
      description: 'Record the purchase of your property.',
      fields: [
        amountField('Cost'),
        dateField('Date of purchase'),
        currencyField(),
      ],
    },
    VALUE_STEP,
    TAGS_STEP,
    SUMMARY_STEP,
  ],
  records: [
    {
      key: 'property',
      label: 'Property',
      icon: House,
      tone: 'brand',
      transactionType: 'add position',
      heading: 'assetName',
      fields: ['amount', 'date', 'currency', 'description'],
    },
  ],
  constants: { assetType: PROPERTY_TYPE },
  defaultTags: DEFAULT_TAGS,
  create,
}
